import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "./logo.svg";
import "./App.css";
import LanguageSelector from "./components/LanguageSelector";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  
  const navigation = [
    {
      name: t('nav.home'),
      href: "/",
    },

    {
      name: t('nav.about'),
      href: "/sobre-nosotros",
    },

    {
      name: t('nav.machinery'),
      href: "/maquinaria",
    },

    {
      name: t('nav.quality'),
      href: "/sistema-de-calidad",
    },

    {
      name: t('nav.products'),
      href: "/productos",
    },

    {
      name: t('nav.blog'),
      href: "/blog",
    },

    {
      name: t('nav.contact'),
      href: "/contacto",
    },
  ];
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="px-8 md:px-[100px] py-4 bg-white relative">
      <nav className="flex items-center space-x-8 justify-between">
        <Link to="/" className="flex items-center" onClick={closeMenu}>
          <img src={logo} className="" alt="logo" loading="eager" decoding="async" fetchPriority="high" />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-[#0867B1] hover:text-[#104D8F] transition-colors duration-200 font-medium ${
                location.pathname === item.href && "!text-[#021C42]"
              }`}
            >
              {item.name}
            </Link>
          ))}
          <LanguageSelector />
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1.5"
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-0.5 bg-[#050038] transition-all duration-300 ${
              isMenuOpen ? "rotate-45 translate-y-2" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-[#050038] transition-all duration-300 ${
              isMenuOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-[#050038] transition-all duration-300 ${
              isMenuOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          ></span>
        </button>
      </nav>

      {/* Mobile Navigation Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 transition-all duration-300 ${
          isMenuOpen
            ? "opacity-100 visible h-[500px]"
            : "opacity-0 invisible max-h-0"
        }`}
      >
        <div className="px-6 py-4 space-y-4">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              onClick={closeMenu}
              className={`block text-[#050038] hover:text-[#104D8F] transition-colors duration-200 font-medium py-2 ${
                location.pathname === item.href ? "text-blue-B" : ""
              }`}
            >
              {item.name}
            </Link>
          ))}
          <div className="pt-4 border-t border-gray-200">
            <LanguageSelector />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
